import type { InvoiceQuerySchema } from './schemas';

/** Void invoice rows: grayscale + reduced opacity on cells (tr filter is inconsistent); no row background tint. */
export const INVOICE_VOID_ROW_CLASS = '[&_td]:grayscale [&_td]:opacity-40';

/** In-flight send: subtle lock — reduced opacity, no click-through. */
export const INVOICE_SENDING_ROW_CLASS = 'pointer-events-none [&_td]:opacity-50';

export function getVoidRowClassNameForInvoiceQuery(row: InvoiceQuerySchema): string | undefined {
  return row.status === 'void' ? INVOICE_VOID_ROW_CLASS : undefined;
}

export function getSendingInvoiceRowClassName(
  invoiceId: number | string,
  sendingInvoiceId: number | null | undefined
): string | undefined {
  if (sendingInvoiceId == null) {
    return undefined;
  }
  return String(invoiceId) === String(sendingInvoiceId) ? INVOICE_SENDING_ROW_CLASS : undefined;
}

type BatchInvoiceTableRow = {
  isBatch: boolean;
  status: InvoiceQuerySchema['status'];
  id: number | string;
};

export function getVoidRowClassNameForBatchInvoiceRow(row: BatchInvoiceTableRow): string | undefined {
  if (row.isBatch) return undefined;
  return row.status === 'void' ? INVOICE_VOID_ROW_CLASS : undefined;
}

export function getInvoiceListRowClassName(
  row: InvoiceQuerySchema,
  sendingInvoiceId: number | null | undefined
): string | undefined {
  const voidClass = getVoidRowClassNameForInvoiceQuery(row);
  const sendingClass = getSendingInvoiceRowClassName(row.id, sendingInvoiceId);

  if (voidClass && sendingClass) {
    return `${voidClass} ${sendingClass}`;
  }

  return voidClass ?? sendingClass;
}

export function getBatchInvoiceListRowClassName(
  row: BatchInvoiceTableRow,
  sendingInvoiceId: number | null | undefined
): string | undefined {
  const voidClass = getVoidRowClassNameForBatchInvoiceRow(row);
  const sendingClass = row.isBatch ? undefined : getSendingInvoiceRowClassName(row.id, sendingInvoiceId);

  if (voidClass && sendingClass) {
    return `${voidClass} ${sendingClass}`;
  }

  return voidClass ?? sendingClass;
}
